import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import ReCAPTCHA from "react-google-recaptcha";
import ReactGA from 'react-ga4';

function Webinars() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const onRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setError('');

    if (!recaptchaToken) {
      setError('Please complete the reCAPTCHA verification.');
      setIsSending(false);
      return;
    }

    try {
      const response = await fetch('/api/sendEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, type: 'webinar', recaptchaToken }),
      });

      if (response.ok) {
        ReactGA.event({
          category: 'Lead',
          action: 'webinar_signup_success',
          label: 'Webinar Signup',
        });
        setSubmitted(true);
        setEmail('');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to send request. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Clariti AI Webinars | Banking Pricing Strategy</title>
        <meta name="description" content="Join our live sessions and watch recordings on pricing optimisation for banks. Stay updated with Clariti AI." />
        <link rel="canonical" href="https://www.clariti.ai/webinars" />
        <meta property="og:title" content="Clariti AI Webinars | Banking Pricing Strategy" />
        <meta property="og:description" content="Live and on-demand sessions on pricing optimisation, data analytics, and banking strategy." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.clariti.ai/webinars" />
        <meta name="twitter:title" content="Clariti AI Webinars | Banking Pricing Strategy" />
        <meta name="twitter:description" content="Follow Clariti AI webinars for practical pricing strategy guidance for banks." />
      </Helmet>
      {/* Hero */}
      <section className="resources-hero">
        <div className="container">
          <h1>Webinars</h1>
          <p>Live sessions and recordings on pricing optimisation for banks.</p>
        </div>
      </section>

      {/* Coming Soon */}
      <section className="coming-soon-section">
        <div className="container">
          <div className="coming-soon-box">
            <p>
              Coming soon. Sign up to be notified when we announce our first webinar.
            </p>
            {!submitted ? (
              <form className="notify-form" onSubmit={handleSubmit} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                {error && <div className="form-error" style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
                
                <div style={{ display: 'flex', gap: '12px', width: '100%', flexWrap: 'wrap' }}>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{ flex: '1 1 200px' }}
                  />
                  <button type="submit" className="btn btn-primary" disabled={isSending}>
                    {isSending ? 'Sending...' : 'Notify me'}
                  </button>
                </div>

                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                  {process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={onRecaptchaChange}
                    />
                  ) : (
                    <div style={{ color: 'red', border: '1px solid red', padding: '10px' }}>
                      Error: reCAPTCHA Site Key is missing. Please add REACT_APP_RECAPTCHA_SITE_KEY to your .env file.
                    </div>
                  )}
                </div>
              </form>
            ) : (
              <p className="notify-success">
                Thanks! We'll be in touch when we have news.
              </p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Webinars;
